import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { PayRatesFeatureState } from '../interfaces/shared.interface';
import { PayRatesAPIActions } from '../actions/pay-rates.actions';

const initialState: PayRatesFeatureState = {
  // we can have touchless groups or default sections here
  maxRate: 0,
  minRate: 0,
};

const reducer: ActionReducer<PayRatesFeatureState> = createReducer(
  initialState,
  on(
    PayRatesAPIActions.loadedPayRatesSuccessfully,
    (state, { payRates }): PayRatesFeatureState => payRates,
  ),
);

export function payRatesReducer(
  state: PayRatesFeatureState = initialState,
  action: Action,
): PayRatesFeatureState {
  return reducer(state, action);
}
